// crewbit-admin/src/pages/Money/Settings/Taxes.tsx
//
// /money/settings/taxes — Taxes sub-screen.

import { useEffect } from 'react';
import { PageHeader } from '../../../components/common/PageHeader';
import TaxesPanel from '../../../components/money/settings/TaxesPanel';
import { useActiveBusinessStore } from '../../../hooks/useActiveBusiness';
import { admin, spacing } from '../../../styles/tokens';

const pageStyle: React.CSSProperties = {
  padding: spacing.xl,
  background: admin.bg,
  minHeight: '100vh',
};

export function MoneySettingsTaxes() {
  const businessId = useActiveBusinessStore((s) => s.activeBusinessId);

  useEffect(() => {
    document.title = 'CrewBit · Tax settings';
  }, []);

  return (
    <div style={pageStyle}>
      <PageHeader
        title="Taxes"
        description="HST/GST registration, tax mode, mileage rates."
        back={{ to: '/money/settings', label: 'Money settings' }}
      />
      <TaxesPanel businessId={businessId} />
    </div>
  );
}
